
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from "@headlessui/vue";
import { CheckCircleIcon } from "@heroicons/vue/20/solid";
import { defineComponent } from "vue";
import "@/assets/styles/custom.css";
import MainButton from "@/components/UI/MainButton.vue";
import ModalTW from "@/components/UI/ModalTW.vue";
import { SchedulerProPdfExportConfig } from "@/types/SchedulerPro";

export default defineComponent({
  name: "PdfExportModal",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const data: SchedulerProPdfExportConfig = {
      rowsRange: "all",
      scheduleRange: "completeview",
      rowsRangeList: ["all", "visible"],
      scheduleRangeList: ["completeview", "currentview"],
    };

    return data;
  },
  emits: ["canceled", "confirmed"],
  components: {
    RadioGroupLabel,
    RadioGroupOption,
    RadioGroup,
    CheckCircleIcon,
    MainButton,
    ModalTW,
  },
  watch: {
    open(newValue) {
      if (newValue) {
        this.rowsRange = "all";
        this.scheduleRange = "completeview";
      }
    },
  },
  methods: {
    confirm() {
      this.$emit("confirmed", {
        rowsRange: this.rowsRange,
        scheduleRange: this.scheduleRange,
      } as SchedulerProPdfExportConfig);
    },
  },
});
